import { useEffect, useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { NumericFormat } from 'react-number-format';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useGetKpiDashboardMutation, useKpiDashboardMutation } from '../services/home';
import yesterday from '../images/yesterday.png';
import LoadingPage from './loadingPage';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

let dateTargetRT = moment().startOf('month');
export default function KPIDashboard() {
  if(!window.localStorage.getItem('token'))
    window.location.href = `${BASE_NAME}/login`;

  ModuleRegistry.registerModules([ AllCommunityModule ]);
  const navigate = useNavigate();
  const [getDataKpi, dataKpi] = useGetKpiDashboardMutation();
  const [kpiDashboard, dataKpiDashboard] = useKpiDashboardMutation();
  const [dataLoaded, setDataLoaded] = useState({MTD: [], Target: [], YTD: [], YTG: [], STATUS: [], StatusTarget: []});
  const [columns, setCoumns] = useState([]);
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [dateRange, setDateRange] = useState({from: moment().startOf('month'), to: moment()});
  const [anchorEl, setAnchorEl] = useState(null);
  const [dateTarget, setDateTarget] = useState(moment().startOf('month'));
  const [sttTarget, setSttTarget] = useState([]);
  const user = JSON.parse(window.localStorage.getItem("user"));

  useEffect(() => {
    setDataLoaded([]);
    getDataKpi({'type': 'MTD', 'fromdate': moment(dateRange.from).format('DD/MM/YYYY'), 'todate': moment(dateRange.to).format('DD/MM/YYYY')});

    // const intervalId = setInterval(() => {
    //   getDataKpi({'type': 'MTD', 'fromdate': moment(dateRange.from).format('DD/MM/YYYY'), 'todate': moment(dateRange.to).format('DD/MM/YYYY')});
    // }, 300000); // Updates count every 1 second

    // // Cleanup function to clear the interval when the component unmounts
    // return () => {
    //   clearInterval(intervalId);
    // };
  }, []);

  useEffect(() => {
    if(dataKpi.data){
      const data = JSON.parse(dataKpi.data);
      if(dataKpi.originalArgs.type == "MTD"){
        setDataLoaded({...dataLoaded, MTD: data});
        if(!dataLoaded.TargetArgs || (dataLoaded.TargetArgs && dataLoaded.TargetArgs.fromdate != moment(dateTargetRT).format('DD/MM/YYYY')))
          getDataKpi({'type': 'Target', 'fromdate': moment(dateTargetRT).format('DD/MM/YYYY'), 'todate': moment(dateTargetRT).endOf('month').format('DD/MM/YYYY')});
      }
      else if(dataKpi.originalArgs.type == "Target"){
        setDataLoaded({...dataLoaded, Target: data, TargetArgs: dataKpi.originalArgs});
        getDataKpi({'type': 'YTD', 'fromdate': moment(dateTargetRT).format('DD/MM/YYYY'), 'todate': moment(dateTargetRT).endOf('month').format('DD/MM/YYYY')});
      }
      else if(dataKpi.originalArgs.type == "YTD"){
        setDataLoaded({...dataLoaded, YTD: data});
        getDataKpi({'type': 'YTG', 'fromdate': moment(dateTargetRT).format('DD/MM/YYYY'), 'todate': moment(dateTargetRT).endOf('month').format('DD/MM/YYYY')});
      }
      else if(dataKpi.originalArgs.type == "YTG"){
        setDataLoaded({...dataLoaded, YTG: data});
        getDataKpi({'type': 'ProductStatus', 'fromdate': moment(dateRange.from).format('DD/MM/YYYY'), 'todate': moment(dateRange.to).format('DD/MM/YYYY')});
      }
      else if(dataKpi.originalArgs.type == "ProductStatus"){
        let total = {Desc: 'Total', D2C: 0, Online: 0, B2B: 0, Country: 0};
        data.map(m=>{
          total.D2C += m.D2C; total.Online += m.Online; total.B2B += m.B2B; total.Country += m.Country;
        })
        let vsTarget = {Desc: 'Var vs Target%', D2C: 0, Online: 0, B2B: 0, Country: 0};
        setDataLoaded({...dataLoaded, STATUS: [...data, total, vsTarget]});
        getDataKpi({'type': 'StatusTarget', 'fromdate': moment(dateTargetRT).format('DD/MM/YYYY'), 'todate': moment(dateTargetRT).endOf('month').format('DD/MM/YYYY')});
      }
      else if(dataKpi.originalArgs.type == "StatusTarget"){
        let total = {Desc: 'Total', D2C: 0, Online: 0, B2B: 0, Country: 0};
        data.map(m=>{
          total.D2C += m.D2C; 
          total.Online += m.Online; 
          total.B2B += m.B2B; 
          total.Country += m.Country;
        })
        setSttTarget([...data, total]);
      }
      if(data.length && !columns.length)
        getCoumns(data[0]);
    }
  }, [dataKpi]);

  useEffect(() => {
    let sttTg = [...sttTarget];
    let total = sttTg.find(f=>f.Desc == 'Total');
    if(total){
      total.D2C = 0; total.Online = 0; total.B2B = 0; total.Country = 0;
      sttTg.map(m=>{
        m.Country = m.D2C + m.Online + m.B2B;
        if(m.Desc != 'Total'){
          total.D2C += m.D2C; 
          total.Online += m.Online; 
          total.B2B += m.B2B; 
          total.Country += m.Country;
        }
      });
    }
    let dtLoaded = {...dataLoaded};
    let sttTotal = dtLoaded.STATUS.find(f=>f.Desc == 'Total');
    let sttVS = dtLoaded.STATUS.find(f=>f.Desc == 'Var vs Target%');
    if(sttTotal && sttVS && total){
      sttVS.D2C = sttTotal.D2C/total.D2C * 100; 
      sttVS.Online = sttTotal.Online/total.Online * 100; 
      sttVS.B2B = sttTotal.B2B/total.B2B * 100; 
      sttVS.Country = sttTotal.Country/total.Country * 100;
    }
    setDataLoaded({...dtLoaded, StatusTarget: sttTg});
  }, [sttTarget])

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: false,
        sortable: false,
        resizable: true,
        minWidth: 50,
        width: key == 'Desc' ? 140 : 110,
        wrapText: key=="Desc" ? true : false,
        autoHeight: true,
        flex: key == 'Desc' ? 10 : 7,
        cellStyle: () => ((key=="D2C" || key=="Online" || key=="B2B" || key=="Country")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="SuggestOrderWH" ? "bold" : ""
        }:null),
        valueFormatter: params => key!="Desc" && params.data[key] ?
                      ((params.data['Desc']=='Netsales' || params.data['Desc']=='SPM')
                        ? params.data[key].toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                        : `${params.data[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`)
                      : params.data[key]
      }
    });
    setCoumns(cols);
  }

  const getRowClass = useCallback(params => {
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    wrapperBorder: { style: 'solid', width: 1, color: '#ccc' },
    headerRowBorder: false,
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const defaultColDef = {
    cellClass: 'cell-custom font-lager',
    headerClass: 'cell-custom font-lager' 
  };

  const handleOpenDate = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDate = () => {
    setAnchorEl(null);
    setRange(dateRange);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onSelectRange=()=>{
    setDateRange(range);
    setAnchorEl(null);
    if(range && range.to){
      dateTargetRT = moment(range.to).startOf('month');
      setDateTarget(dateTargetRT);
      getDataKpi({'type': 'MTD', 'fromdate': moment(range.from).format('DD/MM/YYYY'), 'todate': moment(range.to).format('DD/MM/YYYY')});
    }
  }

  const handleChangeDateTarget=(value)=>{
    dateTargetRT = value;
    setDateTarget(dateTargetRT);
  }

  const onChangeDateTarget=()=>{
    if(dataLoaded.TargetArgs && dataLoaded.TargetArgs.fromdate != moment(dateTargetRT).format('DD/MM/YYYY'))
      getDataKpi({'type': 'Target', 'fromdate': moment(dateTargetRT).format('DD/MM/YYYY'), 'todate': moment(dateTargetRT).endOf('month').format('DD/MM/YYYY')});
  }

  const handleYesterday=()=>{
    const yesterday = {from: moment().add('days', -1), to: moment().add('days', -1)};
    setDateRange(yesterday);
    setAnchorEl(null);
    if(yesterday && yesterday.to){
      dateTargetRT = moment(yesterday.to).startOf('month');
      setDateTarget(dateTargetRT);
      getDataKpi({'type': 'MTD', 'fromdate': moment(yesterday.from).format('DD/MM/YYYY'), 'todate': moment(yesterday.to).format('DD/MM/YYYY')});
    }
  }

  const handleToday=()=>{
    const today = {from: moment(), to: moment()};
    setDateRange(today);
    setAnchorEl(null);
    if(today && today.to){
      getDataKpi({'type': 'MTD', 'fromdate': moment(today.from).format('DD/MM/YYYY'), 'todate': moment(today.to).format('DD/MM/YYYY')});
    }
  }

  const onChangeSttTarget = (value, index, key) =>{
    const numericValue = Number(value);
    let changeQty = 0;
    if(Number.isInteger(numericValue))
      changeQty = (parseInt(value) < 0 ? 0 : parseInt(value));

    let sttTg = [...sttTarget];
    sttTg[index][key] = changeQty;
    setSttTarget(sttTg);
  }

  const saveStatusTarget = async () =>{
    try {
      for (const m of sttTarget) {
        if(m.Desc == 'N' || m.Desc == 'R' || m.Desc == 'B'){
          const value2 = `D2C${m.D2C||0}Online${m.Online||0}B2B${m.B2B||0}`;
          await kpiDashboard({
            'type': 'SaveStatusTarget', 'name': m.Desc, 
            'fromdate': moment(dateTargetRT).format('01/MM/YYYY'),
            'value2': value2
          }).unwrap();
        }
      }
    } catch (error) {
      console.error("Failed to save target:", error);
    }
  }

  const tableRow=(row, index, type)=>{
    return <TableRow key={row.Desc} className={index % 2 === 0 ? 'grid-odd-rows' : ''}>
              {dataLoaded.MTD.length && Object.keys(dataLoaded.MTD[0]).map((key) => (
              <TableCell align={key=='Desc'?'left':'right'} key={row.Desc+key} sx={{ border: '1px solid silver', padding: 1, fontSize: '1rem' }}>
                {type == 'StatusTarget' && row.Desc != 'Total' && (user.id == 89 || user.id == 878) && (key == 'D2C' || key == 'Online' || key == 'B2B')?
                  <NumericFormat size="small"
                    value={row[key]}
                    onValueChange={(values) => { onChangeSttTarget(values.value||0, index, key); }}
                    customInput={TextField}
                    thousandSeparator={true}
                    decimalScale={0}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    // label="Enter Amount"
                    variant="outlined"
                    fullWidth
                    displayType={'input'}
                    inputProps={{ style: { textAlign: 'right', padding: '6.5px' } }}
                  />
                  :<label>
                    {key=='Desc'?row[key] : new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: row['Desc'].includes('%')?2:0,
                      maximumFractionDigits: row['Desc'].includes('%')?2:0,
                    }).format(row[key])} {row['Desc'].includes('%') && key!='Desc'?'%':''}
                  </label>
                }
              </TableCell>
              ))
            }
          </TableRow>
  }

  const tableCellHeader=(key, tbl)=>{
    return <TableCell align="center" key={key} sx={{ border: '1px solid silver', padding: 1, width: key=='Desc'?'24%':'19%'
      , fontSize: '1rem', fontWeight: 'bold', backgroundColor: (tbl=='MTD' || tbl=='YTD')?'#ddfcff':'#ffecec' }}>{key}</TableCell>
  }

  return (
    <div style={{marginTop: '10px', padding: '0 10px'}}>
      { (dataKpi.isLoading || dataKpi.isLoading) && <LoadingPage /> }
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardHeader title={<div>
              MTD<div style={{float: 'right'}}>
                <Box onClick={handleYesterday} component="img" src={yesterday} sx={{ width: 85, float: 'left', marginRight: 1, cursor: 'pointer' }} />
                <Button variant="contained" onClick={handleToday} color="primary"
                  size='small' style={{height: '20px', float: 'left', marginRight: '8px', textTransform: 'none'}}>
                  Today
                </Button>
                <Button aria-describedby={id} variant="contained" onClick={handleOpenDate} color="primary"
                  size='small' style={{height: '20px', width: '20px', minWidth: '20px', float: 'left', marginRight: '5px'}}>
                  <DateRangeIcon />
                </Button>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleCloseDate}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <div style={{padding: '5px 10px 10px 10px'}}>
                    <DayPicker mode="range" selected={range} onSelect={setRange}
                    footer={
                      <div style={{float: 'right'}}>
                        <Button onClick={()=>setRange(null)}>Clear</Button>
                        <Button onClick={handleCloseDate}>Cancel</Button>
                        <Button onClick={onSelectRange}>Ok</Button>
                      </div>
                    } />
                  </div>
                </Popover>
                <label style={{float: 'left'}}>{dateRange?moment(dateRange.from).format("DD/MM/YYYY"):''}</label>
                <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
                <label style={{float: 'left'}}>{dateRange?(moment(dateRange.to).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY") ? 
                                                  moment().format("DD/MM/YYYY HH:mm") : moment(dateRange.to).format("DD/MM/YYYY 23:59")):''}</label>
                </div>
            </div>} 
            style={{ backgroundColor: '#7de6ff', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoaded.MTD && dataLoaded.MTD.length ? Object.keys(dataLoaded.MTD[0]).map((key) => (
                      tableCellHeader(key, 'MTD')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoaded.MTD && dataLoaded.MTD.length ? dataLoaded.MTD.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          <Card sx={{mt: 1}}>
            <CardHeader title={<div>TARGET<div style={{float: 'right'}}>
              <div className='custom-select-month'>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                    <DatePicker label={''} views={['month', 'year']} style={{width: '30px'}} 
                    value={dateTarget} onChange={handleChangeDateTarget} onClose={onChangeDateTarget} />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).format("DD/MM/YYYY"):''}</label>
              <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).endOf('month').format("DD/MM/YYYY"):''}</label>
              </div></div>} 
            style={{ backgroundColor: '#ffd2cc', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoaded.Target && dataLoaded.Target.length ? Object.keys(dataLoaded.Target[0]).map((key) => (
                      tableCellHeader(key, 'Target')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoaded.Target && dataLoaded.Target.length ? dataLoaded.Target.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardHeader title={<div>YTD<div style={{float: 'right'}}>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).startOf('year').format("DD/MM/YYYY"):''}</label>
              <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).add('month', -1).endOf('month').format("DD/MM/YYYY"):''}</label>
              </div></div>} 
            style={{ backgroundColor: '#7de6ff', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoaded.YTD && dataLoaded.YTD.length ? Object.keys(dataLoaded.YTD[0]).map((key) => (
                      tableCellHeader(key, 'YTD')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoaded.YTD && dataLoaded.YTD.length ? dataLoaded.YTD.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          <Card sx={{mt: 1}}>
            <CardHeader title={<div>YTG<div style={{float: 'right'}}>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).startOf('month').format("DD/MM/YYYY"):''}</label>
              <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).endOf('year').endOf('month').format("DD/MM/YYYY"):''}</label>
              </div></div>} 
            style={{ backgroundColor: '#ffd2cc', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoaded.YTG && dataLoaded.YTG.length ? Object.keys(dataLoaded.YTG[0]).map((key) => (
                      tableCellHeader(key, 'YTG')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoaded.YTG && dataLoaded.YTG.length ? dataLoaded.YTG.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }} sx={{mb: 1}}>
          <Card>
            <CardHeader title={<div>STATUS<div style={{float: 'right'}}>
              <label style={{float: 'left'}}>{dateRange?moment(dateRange.from).format("DD/MM/YYYY"):''}</label>
              <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
              <label style={{float: 'left'}}>{dateRange?(moment(dateRange.to).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY") ? 
                                                  moment().format("DD/MM/YYYY HH:mm") : moment(dateRange.to).format("DD/MM/YYYY 23:59")):''}</label>
              </div></div>} 
            style={{ backgroundColor: '#7de6ff', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {dataLoaded.STATUS && dataLoaded.STATUS.length ? Object.keys(dataLoaded.STATUS[0]).map((key) => (
                      tableCellHeader(key, 'STATUS')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLoaded.STATUS && dataLoaded.STATUS.length ? dataLoaded.STATUS.map((row, index) => (
                    tableRow(row, index)
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} sx={{mb: 1}}>
          <Card>
            <CardHeader title={<div>STATUS TARGET<div style={{float: 'right'}}>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).format("DD/MM/YYYY"):''}</label>
              <ArrowForwardIcon style={{float: 'left', height: '20px'}}/>
              <label style={{float: 'left'}}>{dateTarget?moment(dateTarget).endOf('month').format("DD/MM/YYYY"):''}</label>
              </div>{(user.id == 89 || user.id == 878)?
                <Button variant="contained" onClick={saveStatusTarget} color="primary"
                  size='small' style={{height: '20px', marginLeft: '8px', padding: '0', textTransform: 'none'}}>
                  Save
                </Button>:''}</div>} 
            style={{ backgroundColor: '#ffd2cc', padding: '10px'} }
            titleTypographyProps={{ fontSize: '1rem', fontWeight: 'bold' }}/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {sttTarget && sttTarget.length ? Object.keys(sttTarget[0]).map((key) => (
                      tableCellHeader(key, 'StatusTarget')
                    ))
                    :<TableCell></TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sttTarget && sttTarget.length ? sttTarget.map((row, index) => (
                    tableRow(row, index, 'StatusTarget')
                  )):<TableRow></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}